import styled from "styled-components";

const LogIconStyled = styled.div`
  img {
    position: fixed;
    margin-left: -12rem;
    margin-top: -5.5rem;
  }
`;

export default LogIconStyled;
